import { useState } from "react";
import {
  IconChevronLeft as ChevronLeft,
  IconChevronRight as ChevronRight,
} from "@tabler/icons-react";
import { SectionHeader } from "../shared/SectionHeader";

export function UseCasesSection({ t }) {
  const items = t.usecases.items;
  const [idx, setIdx] = useState(0);
  const total = items.length;

  const go = (n) => setIdx((idx + n + total) % total);
  const goTo = (i) => setIdx(i);

  return (
    <section id="usecases" className="relative py-24 md:py-32 bg-[hsl(var(--surface-elevated))] border-y border-[hsl(var(--border))]">
      <div className="container-x">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <SectionHeader eyebrow={t.usecases.eyebrow} title={t.usecases.title} className="max-w-none" />
        </div>

        <div className="reveal relative mt-12 overflow-hidden rounded-3xl border border-[hsl(var(--border))]">
          <div
            className="flex transition-transform duration-700 ease-[cubic-bezier(0.2,0.8,0.2,1)]"
            style={{ transform: `translateX(-${idx * 100}%)` }}
          >
            {items.map((it, i) => (
              <div key={i} className="relative w-full shrink-0">
                <div className="relative h-[420px] md:h-[520px] w-full">
                  <img src={it.img} alt={it.title} className="absolute inset-0 h-full w-full object-cover" />
                  <div
                    className="absolute inset-0"
                    style={{
                      background:
                        "linear-gradient(180deg, rgba(3,21,63,0.2) 0%, rgba(3,21,63,0.85) 100%)",
                    }}
                  />
                  <div className="absolute inset-0 flex items-end">
                    <div className="container-x w-full pb-10 md:pb-14">
                      <div className="max-w-2xl text-white">
                        <div className="font-mono text-xs uppercase tracking-[0.2em] text-white/70">
                          0{i + 1} / {String(total).padStart(2, "0")}
                        </div>
                        <h3 className="mt-3 font-display text-[clamp(2rem,4vw,3.5rem)] font-medium leading-tight">
                          {it.title}
                        </h3>
                        <p className="mt-3 text-base md:text-lg text-white/85 max-w-xl leading-relaxed">
                          {it.desc}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="pointer-events-none absolute inset-y-0 left-0 right-0 z-20 flex items-center justify-between px-3 md:px-5" data-testid="usecase-controls">
            <button
              onClick={() => go(-1)}
              className="pointer-events-auto grid h-11 w-11 place-items-center rounded-full border border-white/25 bg-black/25 text-white backdrop-blur-md transition-all hover:border-brand hover:bg-brand hover:text-white md:h-12 md:w-12"
              aria-label="Previous"
              data-testid="usecase-prev"
            >
              <ChevronLeft className="h-5 w-5" />
            </button>
            <button
              onClick={() => go(1)}
              className="pointer-events-auto grid h-11 w-11 place-items-center rounded-full border border-white/25 bg-black/25 text-white backdrop-blur-md transition-all hover:border-brand hover:bg-brand hover:text-white md:h-12 md:w-12"
              aria-label="Next"
              data-testid="usecase-next"
            >
              <ChevronRight className="h-5 w-5" />
            </button>
          </div>
        </div>

        <div className="mt-6 flex items-center justify-center gap-2" data-testid="usecase-dots">
          {items.map((_, i) => (
            <button
              key={i}
              onClick={() => goTo(i)}
              aria-label={`Go to slide ${i + 1}`}
              className={`h-1.5 rounded-full transition-all ${
                i === idx ? "w-8 bg-brand" : "w-1.5 bg-[hsl(var(--border))]"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
